const euros = new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" });
export const formatMoney = value => Number.isFinite(value) ? euros.format(value) : "—";

// Catalog option prices are net; customer-facing supplements include the product's VAT.
export const formatSupplement = (price, tax) => {
  const net = Number(price ?? 0);
  const configuredRate = Number(tax?.value ?? tax ?? 21);
  const rate = Number.isFinite(configuredRate) && configuredRate >= 0 ? configuredRate : 21;
  return formatMoney(Number.isFinite(net) ? net * (1 + rate / 100) : NaN);
};
